import { County } from './county';
import { Disease } from './disease';
import { Foundation } from './foundation';
import { FundCity } from './fund-city';
import { FundInsuranceType } from './fund-insurance-type';
import { FundSupportType } from './fund-support-type';
import { State } from './state';

export interface Fund {
  applicationRequirements?: string;
  applicationUrl?: string;
  cities?: FundCity[];
  citiesCount?: any;
  closedDate?: Date;
  color?: string;
  counties?: County[];
  countiesCount?: any;
  description?: string;
  descriptionChangeDate?: Date;
  diseaseType?: string;
  diseases?: Disease[];
  foundation?: Foundation;
  foundationId?: number;
  frequency?: string;
  id?: number;
  fundInsuranceTypes?: FundInsuranceType[];
  fundSupportTypes?: FundSupportType[];
  grantAmount?: number;
  grantAmountDescription?: string;
  guid?: string;
  hasIncomeRequirement?: any;
  hasincomerequirement?: any;
  incomeRequirementDescription?: string;
  incomeRequirementMaxFpl?: number;
  lastUpdated?: Date;
  maxIncome?: any;
  nonFplIncomeRequirement?: any;
  nonfplincomerequirement?: any;
  notes?: string;
  pediatric?: boolean;
  queryDate?: Date;
  queryMessage?: string;
  queryMethod?: string;
  queryState?: string;
  scraperProxy?: boolean;
  scraperProxyCountry?: string;
  state?: string;
  states?: State[];
  status?: string;
  statusDate?: Date;
  url?: string;
  viewedLastWeek?: any;
  websiteUrl?: string;
}
